"use client";

import * as React from "react";
import { HStack } from "../layout/HStack";
import { Text } from "./text";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  PinterestIcon,
  PinterestShareButton,
  PocketIcon,
  PocketShareButton,
  RedditIcon,
  RedditShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

export interface SocialSharingProps {
  title: string;
  url: string;
  description: string;
  hashtags: string[];
  primaryHashtag?: string;
  image: string;
  source?: string;
  label?: React.ReactNode;
  iconSize?: number;
  className?: string;
  isArticle?: boolean;
}

export const SocialSharing = ({
  title,
  url,
  description,
  hashtags,
  primaryHashtag,
  image,
  source,
  label = "Share",
  iconSize = 25,
  className,
  isArticle = false,
}: SocialSharingProps) => {
  const facebookHashtag = primaryHashtag ?? hashtags[0];

  return (
    <HStack className={className}>
      {typeof label === "string" ? <Text>{label}</Text> : label}
      <PinterestShareButton url={url} media={image} description={description}>
        <PinterestIcon size={iconSize} borderRadius={10} />
      </PinterestShareButton>
      <FacebookShareButton url={url} hashtag={facebookHashtag}>
        <FacebookIcon size={iconSize} borderRadius={10} />
      </FacebookShareButton>
      <TwitterShareButton url={url} hashtags={hashtags} title={title}>
        <TwitterIcon size={iconSize} borderRadius={10} />
      </TwitterShareButton>
      <LinkedinShareButton url={url} title={title} source={source} summary={description}>
        <LinkedinIcon size={iconSize} borderRadius={10} />
      </LinkedinShareButton>
      <WhatsappShareButton url={url} title={title}>
        <WhatsappIcon size={iconSize} borderRadius={10} />
      </WhatsappShareButton>
      <LineShareButton url={url} title={title}>
        <LineIcon size={iconSize} borderRadius={10} />
      </LineShareButton>
      {isArticle && (
        <>
          <RedditShareButton url={url} title={title}>
            <RedditIcon size={iconSize} borderRadius={10} />
          </RedditShareButton>
          <TumblrShareButton url={url} title={title} tags={hashtags} caption={description}>
            <TumblrIcon size={iconSize} borderRadius={10} />
          </TumblrShareButton>
          <PocketShareButton url={url} title={title}>
            <PocketIcon size={iconSize} borderRadius={10} />
          </PocketShareButton>
          <InstapaperShareButton url={url} title={title} description={description}>
            <InstapaperIcon size={iconSize} borderRadius={10} />
          </InstapaperShareButton>
        </>
      )}
      <EmailShareButton url={url} subject={title} body={description}>
        <EmailIcon size={iconSize} borderRadius={10} />
      </EmailShareButton>
    </HStack>
  );
};
